import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import {
  LoaderFunction,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import { ErrorPage } from "./error";
import { Body } from "./Body";
import { getJFT } from "./data/download-jft";
import { DateTime } from "luxon";
import { LoaderData, VersionSchema, sortVersions } from "./types";
import { DEFAULT_VERSION } from "./app-context";
import { z } from "zod";
import { formatMonthAndDay } from "./util";

const jftLoader: LoaderFunction = async ({ request }): Promise<LoaderData> => {
  const url = new URL(request.url);
  const date =
    url.searchParams.get("date") ?? formatMonthAndDay(DateTime.now());
  const rawVersionArray = url.searchParams.getAll("version");
  const rawVersionsParam =
    rawVersionArray.length === 1 && rawVersionArray[0] === "none"
      ? "none"
      : rawVersionArray;
  const versionsParam = z
    .literal("none")
    .or(z.array(VersionSchema))
    .parse(rawVersionsParam);

  const versions =
    versionsParam === "none"
      ? []
      : sortVersions(
          versionsParam.length > 0 ? versionsParam : [DEFAULT_VERSION]
        );
  const parsedDate = parseDate(date);
  const jfts = await getJFT(parsedDate);
  return {
    jfts,
    versions,
    date: parsedDate,
  };
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <Body />,
        loader: jftLoader,
        id: "root",
      },
    ],
  },
]);

function parseDate(dateString: string) {
  const dateRegex = /^\d{1,2}-\d{1,2}$/;
  if (!dateRegex.test(dateString)) {
    throw new Error(`Invalid date string: ${dateString}`);
  }
  const [month, day] = dateString.split("-");
  const monthNum = parseInt(month);
  const dayNum = parseInt(day);
  return { month: monthNum, day: dayNum };
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
